import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

function ListWrappersMenu({ menu = [] }) {
  const { t } = useTranslation(['actions']);
  const { pathname } = useLocation();

  return (
    <nav className="wrapper-list-menu" aria-label={t('actions:a11y_section_menu')}>
      {menu.map((item) => {
        const isActive = item.to === pathname;
        return (
          <div key={item.to} className="wrapper-list-menu__item">
            <Link
              to={item.to}
              className={isActive ? '' : 'wrapper-list-menu__item--inactive'}
              aria-current={isActive ? 'page' : undefined}
            >
              {item.title}
            </Link>
          </div>
        );
      })}
    </nav>
  );
}

ListWrappersMenu.propTypes = {
  menu: PropTypes.array,
};
export default ListWrappersMenu;
